<template>
  <div id="app">
    <Header></Header>
    <div class="main-container">
      <Pre-page :nav="prePageNav"></Pre-page>
      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
              <OneTitle :title="'首页'"></OneTitle>
              <div class="links">
                  <a href="https://www.nongjike.cn" title="首页">首页</a>
                  <a href="njzs.html" title="农技知识">农技知识</a>
                  <a href="bch.html" title="病虫害图谱">病虫害图谱</a>
                  <a href="nzsc.html?type=1" title="农资商城">农资商城</a>
                  <a href="zwal.html" title="应用案例">应用案例</a>
                  <a href="hdsq.html" title="互动社区">互动社区</a>
                  <a href="bl.html" title="猫友部落">猫友部落</a>
                  <a href="xwzx.html" title="新闻中心">新闻中心</a>
                  <a href="gywm_u.html" title="联系我们">联系我们</a>
              </div>
              <OneTitle :title="'农技知识'"></OneTitle>
              <div class="links">
                  <a href="njzs.html?id=14" title="玉米">玉米</a>
                  <a href="njzs.html?id=10" title="小麦">小麦</a>
                  <a href="njzs.html?id=16" title="大豆">大豆</a>
                  <a href="njzs.html?id=18" title="水稻">水稻</a>
                  
              </div>
              <OneTitle :title="'病虫害图谱'"></OneTitle>
              <div class="links">
                  <a href="bch.html?id=47" title="小麦">小麦</a>
                  <a href="bch.html?id=52" title="玉米">玉米</a>
                  <a href="bch.html?id=44" title="油菜">油菜</a>
                  <a href="bch.html?id=62" title="花生">花生</a>
              </div>
              <OneTitle :title="'农资商城'"></OneTitle>
              <div class="links">
                  <a href="nzsc.html?type=1" title="热销爆款">热销爆款</a>
                  <a href="nzsc.html?type=2" title="根施专区">根施专区</a>
                  <a href="nzsc.html?type=3" title="叶喷专区">叶喷专区</a>
                  <a href="nzsc.html?type=4" title="套餐专区">套餐专区</a>
                  <a href="nzscxq.html?id=723b1e45ed3e475eb5289420105bfa60&proSort=4&categoryId=1" title="农拾5亿菌剂">农拾5亿菌剂</a>
                  <a href="nzscxq.html?id=b5ead8e35caf4b9a9e39451ed00cb565&proSort=3&categoryId=1" title="小小根">小小根</a>
                  <a href="nzscxq.html?id=96f36e10bfc34101ae46ec22322618ae&proSort=0&categoryId=1" title="生根防病AB套餐">生根防病AB套餐</a>
              </div>
              <OneTitle :title="'应用案例'"></OneTitle>
              <div class="links">
                  <!-- <a href="cpal.html" title="产品案例">产品案例</a> -->
                  <a href="zwal.html" title="作物案例">作物案例</a>
              </div>
              <OneTitle :title="'互动社区'"></OneTitle>
              <div class="links">
                  <a href="hdsq.html" title="活动专区">活动专区</a>
                  <a href="wdsq.html" title="问答专区">问答专区</a>
              </div>
              <OneTitle :title="'新闻中心'"></OneTitle>
              <div class="links">
                  <a href="xwzx.html?type=0" title="企业动态">企业动态</a>
                  <a href="xwzx.html?type=1" title="行业新闻">行业新闻</a>
              </div>
              <OneTitle :title="'联系我们'"></OneTitle>
              <div class="links">
                  <a href="gywm_u.html" title="关于我们">关于我们</a>
                  <a href="zshz_u.html" title="招商合作">招商合作</a>
                  <a href="zxns_u.html" title="招贤纳士">招贤纳士</a>
                  <a href="xswd_u.html" title="销售网点">销售网点</a>
                  <a href="zxly_u.html" title="在线留言">在线留言</a>
              </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import PrePage from "../components/PrePage.vue";
import OneTitle from "../components/OneTitle.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    // Pagination,
    // Like,
    PrePage,
    OneTitle,
  },
  data: () => {
    return {
      prePageNav: [
        {
          name: "首页",
          to: "/",
        },
        {
          name: "网站地图",
          to: "shopmap.html",
        }
      ],
    };
  },
  beforeMount() {

  },
  methods: {
    pageChange(n) {
      console.log(n);
      this.loading = true;
      this.$axios
        .post(
          `https://m.nongjike.cn/app/community/findComment?userId=1&id=${this.id}&pageNum=${n}&pageSize=10`
        )
        .then((res) => {
          this.comments = res.data.information.list;
          this.loading = false;
          //   this.totalpage = res.data.information.total
        });
    },
  },
  filters: {
    nameNoPhone(nickName) {
      if (!nickName) {
        return nickName;
      } else {
        nickName = nickName.replace(/\d{11}/gi, "***");
        return nickName;
      }
    },
    remarkSplit(arr) {
      if (!arr) {
        return "";
      }
      let names = arr.map((item) => item.remark);
      return names.join("、");
    },
    upTo5(num) {
      num = parseInt((num - 0) * 5);
      if (num - 10000 > 0) {
        num = parseInt(num / 10000) + "w+";
      }
      return num;
    },
    timeAgo(time) {
      let between = Date.now() / 1000 - new Date(time).getTime() / 1000;
      if (between < 0) {
        between += 25200;
      }
      if (between < 3600) {
        return `${~~(between / 60)} 分钟前`;
      } else if (between < 86400) {
        return `${~~(between / 3600)} 小时前`;
      } else {
        return `${time.split(" ")[0]}`;
      }
    },
  },
  mounted: () => {},
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}
video {
  width: 100%;
}
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}

.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}
.links{
    width: 100%;
    display: flex;
    justify-content: flex-start;
}
.links a{
    display: block;
    width: 120px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-right: 24px;
    margin-bottom: 24px;
    color:#333;
}
.research-links {
  margin: 40px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .research-link {
    width: 45%;
    text-align: left;
    vertical-align: bottom;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    span {
      font-size: 14px;
      color: #666;
      margin-right: 16px;
    }
    a {
      color: #333;
      font-size: 16px;
    }
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    padding-bottom: 80px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 30px;
    .articleList {
      width: 100px;
      flex-grow: 1;
    }

    .likeList {
      width: 360px;
    }
  }
}

.product-cont {
  width: 100%;
  overflow: hidden;
  margin: 22px 0;
  img {
    max-width: 100%;
    display: block;
    height: auto !important;
  }
  video {
    max-width: 100%;
    width: 100%;
  }
}
.crop-title {
  font-size: 24px;
  color: #1f1f1f;
  padding-top: 20px;
  text-align: center;
  margin-bottom: 12px;
}
.crop-times {
  padding-bottom: 40px;
}
.crop-infos {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
  .crop-info-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    color: #999;
    font-size: 14px;
    margin-left: 8px;
    line-height: 20px;
    margin-right: 15px;
    .iconfont {
      font-size: 16px;
      margin-right: 4px;
    }
    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
}
.product-cont {
  width: 100%;
  overflow: hidden;
  margin: 40px 0;
  img {
    max-width: 100%;
    display: block;
    height: auto !important;
  }
}
.product-basic {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .product-qrcode {
    margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      font-size: 14px;
      color: #1e1e1e;
    }
    img {
      width: 128px;
      height: 128px;
      display: block;
      margin-right: 8px;
    }
  }
  .product-btn {
    width: 90px;
    height: 30px;
    font-size: 12px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    background: #65b825;
    cursor: pointer;
    position: relative;
    left: 6px;
    color: #fff;
    span {
      vertical-align: middle;
    }
    img {
      width: 12px;
      height: 12px;
      vertical-align: middle;
      margin-left: 2px;
    }
  }
  .product-img {
    width: 394px;
    height: 394px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #e6e6e6;
    background: #fff;
    margin-right: 20px;
    .el-image {
      min-width: 394px;
      height: 394px;
      .image-slot > img {
        width: 394px;
        height: 394px;
        display: block;
      }
    }
  }
  .product-info {
    width: 100px;
    flex-grow: 1;
    padding-top: 16px;
    .title {
      font-size: 24px;
      padding-left: 22px;
      font-weight: bold;
      color: #000;
      position: relative;
      margin-bottom: 10px;
      &::before {
        content: "";
        display: block;
        width: 8px;
        height: 24px;
        background: #65b825;
        position: absolute;
        left: 6px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .product-line {
      font-size: 16px;
      color: #666666;
      margin-bottom: 12px;
      .product-tag {
        color: #65b825;
        margin-right: 10px;
      }
    }
  }
}
</style>
